import Vue from 'vue'
import Toasted from 'vue-toasted'
import axios from '@/util/axios'
import PortalVue from 'portal-vue'
import Loading from '@/components/Loading'
import Vue2TouchEvents from 'vue2-touch-events'

// Debug
// Vue.config.debug = window.config.debug;
// Vue.config.devtools = window.config.debug;

Vue.use(PortalVue)
Vue.use(Vue2TouchEvents)

Vue.use(Toasted, {
    theme: 'nlcaa-app',
    position: 'bottom-right',
    duration: 6000,
})

export default class Website {

    constructor(config) {
        this.bus = new Vue()
        this.config = config
    }

    /**
     * Start the Nova app by calling each of the tool's callbacks and then creating
     * the underlying Vue instance.
     */
    liftOff() {
        let _this = this

        this.app = new Vue({
            el: '#nlcaa-website',
            components: { Loading },
            mounted: function () {
                this.$loading = this.$refs.loading
            },
            methods: {
                google() {
                    App.bus.$emit('google-api-ready')
                }
            }
        })
    }

    /**
     * Return an axios instance configured to make requests to Nova's API
     * and handle certain response codes.
     */
    request(options) {
        if (options !== undefined) {
            return axios(options)
        }

        return axios
    }
}
